import React from 'react';
import { withStyles, CircularProgress } from '@material-ui/core';
import { primaryColor } from '../utils/colors';

const ColorCircularProgress = withStyles({
	root: {
		color: primaryColor,
	},
})(CircularProgress);

const CustomSpinner = props => {
	return <ColorCircularProgress {...props} />;
};

export default CustomSpinner;